import { useDispatch } from 'react-redux'

export const SettingsCheckbox = ({
  property,
  id,
  data,
  update,
  isDisabled = () => false,
}) => {
  const dispatch = useDispatch()
  const { [property]: checked } = data

  const handleChange = e => {
    dispatch(
      update({
        [property]: e.target.checked,
      })
    )
  }

  return (
    <input
      id={id}
      type="checkbox"
      checked={!!checked}
      disabled={isDisabled(data)}
      onChange={handleChange}
    />
  )
}
